<template>
  <div class="role-create app__block">
    <form
      class="role-create__form"
      @submit.prevent="isFormValid() && showConfirmation()"
      novalidate
    >
      <h2 class="role-create__title">
        {{ "role-create.title-create" | globalize }}
      </h2>
      <input-field
        v-model="form.name"
        :label="'role-create.lbl-name' | globalize"
        :error-message="getFieldErrorMessage('form.name')" />
      <textarea-field
        v-model="form.description"
        :label="'role-create.lbl-description' | globalize" />

      <div class="role-create__actions">
        <form-confirmation
          v-if="formMixin.isConfirmationShown"
          @ok="createRole() && redirectToRoleDetails(form.name)"
          @cancel="hideConfirmation"
          :is-pending="isDisabled"
        />
        <template v-else>
          <button
            v-ripple
            type="submit"
            class="app__form-submit-btn app__button-raised"
            :disabled="isDisabled"
          >
            {{ 'role-create.btn-create' | globalize }}
          </button>
        </template>
      </div>
    </form>
  </div>
</template>

<script>
import RolesMixin from '@/vue/mixins/roles.mixin'
import { required } from '@validators'

export default {
  name: 'role-create',
  mixins: [ RolesMixin ],
  validations: {
    form: {
      name: { required },
    },
  },
}
</script>

<style lang="scss" scoped>
.role-create {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 4rem;
}

.role-create__title {
  margin-bottom: 4rem;
}

.role-create__form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 50rem;
}

.role-create__actions {
  display: flex;
  gap: 2rem;
}
</style>
